import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormOptionsSelector from "@babackapp/react-hook-forms-components/form-option-selector";
import useTranslation from "@babackapp/translations/use-translation";
import { FormField } from "@babackapp/ui/components/form";
import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { ReturnReasonFormValues } from "./add-return-reason-dialog";


export default function ReturnReasonOptionsForm() {
  const t = useTranslation();
  const { control, setValue } = useFormContext<ReturnReasonFormValues>();
  const shopifyReasonOptions = useShopifyReturnReasonsOptions();
  const additionalOptions = useAdditionalInfoOptions();

  const shopifyReason = useWatch({ control, name: "shopifyReason" });

  /**
   * When the reason is OTHER, we need a note,
   * when it is not, we can remove that note
   * if it exists
   */
  useEffect(() => {
    if (shopifyReason !== "OTHER") {
      setValue("shopifyReasonNote", "");
    }
  }, [shopifyReason, setValue]);

  return (
    <div className="pt-8 flex flex-col gap-8">
      <FormField
        control={control}
        name="shopifyReason"
        render={({ field: { value, onChange } }) => (
          <FormOptionsSelector
            label={t("settings.reasons.fields.shopifyEquivalence.title")}
            description={t(
              "settings.reasons.fields.shopifyEquivalence.description",
            )}
            options={shopifyReasonOptions}
            value={value}
            onChange={onChange}
          />
        )}
      />

      {shopifyReason === "OTHER" && (
        <FormField
          control={control}
          name="shopifyReasonNote"
          rules={{
            validate: (data) => {
              // if (shopifyReason === "OTHER") {// shoould not be undefined || empty
              if (shopifyReason === "OTHER" && !data) {
                return false;
              }
              return true;
            },
          }}
          render={({ field }) => (
            <FormInput
              label={t("settings.reasons.fields.shopifyNote.title")}
              description={t("settings.reasons.fields.shopifyNote.description")}
              value={field.value ?? ""}
              onChange={field.onChange}
            />
          )}
        />
      )}

      <FormField
        control={control}
        name="images"
        render={({ field: { value, onChange } }) => (
          <FormOptionsSelector
            label={t("settings.reasons.fields.imageField.title")}
            description={t("settings.reasons.fields.imageField.description")}
            options={additionalOptions}
            value={value}
            onChange={onChange}
          />
        )}
      />
      <FormField
        control={control}
        name="comments"
        render={({ field: { value, onChange } }) => (
          <FormOptionsSelector
            label={t("settings.reasons.fields.commentField.title")}
            description={t("settings.reasons.fields.commentField.description")}
            options={additionalOptions}
            value={value}
            onChange={onChange}
          />
        )}
      />
      <FormField
        control={control}
        name="externalId"
        render={({ field }) => (
          <FormInput
            label={t("settings.reasons.fields.externalId.title")}
            description={t("settings.reasons.fields.externalId.description")}
            value={field.value ?? ""}
            onChange={field.onChange}
          />
        )}
      />

    </div>
  );
}


function useAdditionalInfoOptions() {
  const t = useTranslation();
  return [
    {
      key: "NOT_AVAILABLE",
      label: t("settings.reasons.fields.additionalOptions.notAvailable"),
    },
    {
      key: "OPTIONAL",
      label: t("settings.reasons.fields.additionalOptions.optional"),
    },
    {
      key: "REQUIRED",
      label: t("settings.reasons.fields.additionalOptions.required"),
    },
  ];
}


function useShopifyReturnReasonsOptions() {
  const t = useTranslation();
  return [
    {
      key: "COLOR",
      label: t("settings.reasons.shopifyReturnReasons.color"),
      description: t("settings.reasons.shopifyReturnReasonsDetails.color"),
    },
    {
      key: "DEFECTIVE",
      label: t("settings.reasons.shopifyReturnReasons.defective"),
      description: t("settings.reasons.shopifyReturnReasonsDetails.defective"),
    },
    {
      key: "NOT_AS_DESCRIBED",
      label: t("settings.reasons.shopifyReturnReasons.notAsDescribed"),
      description: t(
        "settings.reasons.shopifyReturnReasonsDetails.notAsDescribed",
      ),
    },
    {
      key: "OTHER",
      label: t("settings.reasons.shopifyReturnReasons.other"),
      description: t("settings.reasons.shopifyReturnReasonsDetails.other"),
    },
    {
      key: "STYLE",
      label: t("settings.reasons.shopifyReturnReasons.style"),
      description: t("settings.reasons.shopifyReturnReasonsDetails.style"),
    },
    {
      key: "SIZE_TOO_LARGE",
      label: t("settings.reasons.shopifyReturnReasons.sizeTooLarge"),
      description: t(
        "settings.reasons.shopifyReturnReasonsDetails.sizeTooLarge",
      ),
    },
    {
      key: "SIZE_TOO_SMALL",
      label: t("settings.reasons.shopifyReturnReasons.sizeTooSmall"),
      description: t(
        "settings.reasons.shopifyReturnReasonsDetails.sizeTooSmall",
      ),
    },
    {
      key: "UNKNOWN",
      label: t("settings.reasons.shopifyReturnReasons.unknown"),
      description: t("settings.reasons.shopifyReturnReasonsDetails.unknown"),
    },
    {
      key: "UNWANTED",
      label: t("settings.reasons.shopifyReturnReasons.unwanted"),
      description: t("settings.reasons.shopifyReturnReasonsDetails.unwanted"),
    },
    {
      key: "WRONG_ITEM",
      label: t("settings.reasons.shopifyReturnReasons.wrongItem"),
      description: t("settings.reasons.shopifyReturnReasonsDetails.wrongItem"),
    },
  ];
}
